import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'
import common from './modules/Common'

Vue.use(Vuex)
const store = new Vuex.Store({
  plugins: [createPersistedState()],
  // root
  // getters,
  // put all modules into vuex
  modules: {
    common
  },
  // Strict mode, prohibiting direct modification of state
  strict: true
})
export default store

/*
└── store
    ├── index.js           // root 組合所有 modules 的地方
    ├── actions.js         // root 最外層的 action
    ├── mutations.js       // root 最外層的 mutation 可以改變所有模組的 state
    ├── getter.js          // root 最外層的 getter 可以拿到所有模組的 state
    ├── mutations_types.js // 所有 mutation key 存放的地方
    ├── modules
    │   └── Login
    │       ├── index.js      // 組合 Login
    │       ├── actions.js    // Login action
    │       └── mutations.js  // Login state, mutation
    │   └── License
    │       ├── index.js      // 組合 License
    │       ├── actions.js    // License action
    │       └── mutations.js  // License state, mutation
    ...

vuex 的原則：
1. 只有 mutation 可以改變 state。
2. 非同步的事件應該在 action 處理。
3. mutation 只能處理同步事件。
*/



// WEBPACK FOOTER //
// ./src/store/index.js